var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444-164.77q-98.54-13.62-165.27-88.15Q212-327.46 212-430q0-56 21.08-103.88 21.08-47.89 56.46-84.2l36.77 36.77q-28.85 28.62-45.58 68.04Q264-473.85 264-430q0 81 51.69 139.62 51.69 58.61 128.31 72.61v53Zm72 .77v-53q76.62-14.54 128.31-73.46Q696-349.38 696-430q0-90-63-153t-153-63h-18.15l56 56-37.16 36.15L362.54-672l118.15-118.15L517.85-753l-55 55H480q111.54 0 189.77 78.23T748-430q0 102.92-66.92 177.58Q614.15-177.77 516-164Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.2b85e55c7f43979ee45663d993b19f27.svg";
export { ForwardRef as ReactComponent };